import { render, staticRenderFns } from "./TipoPagoComponent.vue?vue&type=template&id=1c089a64"
import script from "./TipoPagoComponent.vue?vue&type=script&lang=js"
export * from "./TipoPagoComponent.vue?vue&type=script&lang=js"
import style0 from "./TipoPagoComponent.vue?vue&type=style&index=0&id=1c089a64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports